import React from 'react';
import { handleHttpResponse } from '../../lib/Helpers';
import User from '../../lib/User';
import WaitlistLib from '../../lib/Waitlist';
import WaitlistFilters from './WaitlistFilters/WaitlistFilters';
import WaitlistUsersContainer from './WaitlistUsersContainer';
import LoadMoreButton from './LoadMoreButton';
import { MessageModal } from '../../components/Modals'
import './Waitlist.css';

class Waitlist extends React.Component {
    initialFilters = {
        buckets: ['Inbox'],
        completion: [],
        assignees: [],
        profiles: 'All'
    }

    limit = 100

    initialState = {
        loading: false,
        search: '',
        users: [],
        filters: this.initialFilters,
        offset: 0
    }

    state = Object.assign({}, this.initialState); // So that reloading works

    addUsers(new_users) {
        new_users = new_users.map((u) => new User(u))
        const users = this.state.users.slice();
        this.setState({ users: users.concat(new_users) })
    }

    removeCheckboxFilter(key, currentFilter) {
        const filters = Object.assign({}, this.state.filters);
        filters[key].splice(filters[key].indexOf(currentFilter), 1);
        this.setState({
            filters: filters
        })
    }

    addCheckboxFilter(key, newFilter) {
        const filters = Object.assign({}, this.state.filters);
        filters[key].push(newFilter);
        this.setState({
            filters: filters
        })
    }

    updateRadioFilter(key, newValue) {
        const filters = Object.assign({}, this.state.filters);
        filters[key] = newValue;
        this.setState({
            filters: filters
        })
    }

    applyFilters() {
        // console.log(this.state.filters);
        this.setState({
            offset: 0,
            users: [],
            search: ''
        }, () => (this.loadWaitlist(this.state.filters)));
    }

    search() {
        this.setState({
            offset: 0,
            users: [],
            filters: Object.assign({}, this.initialFilters, { buckets: [] })
        }, () => this.loadWaitlist({ search: this.state.search }));
    }

    loadMore() {
        this.setState({ offset: this.state.offset + this.limit }, function() {
            if (this.state.search) {
                this.loadWaitlist({ search: this.state.search });
            } else {
                this.loadWaitlist(this.state.filters);
            }
        }.bind(this));
    }

    reload() {
        this.setState(this.initialState, function() {
            this.loadWaitlist(this.state.filters)
        }.bind(this));
    }

    loadWaitlist(filters) {
        const self = this;
        const waitlist = WaitlistLib.loadWaitlist(Object.assign({
            limit: self.limit,
            offset: self.state.offset
        }, filters));

        this.setState({ loading: true });

        waitlist.then(function(response) {
            return handleHttpResponse(response)
                .then(function(result) {
                    self.addUsers(result.users);
                    self.setState({ loading: false });
                }).catch(function(err) {
                    console.log(err);
                    self.setState({ loading: false });
                    self.showModal(err, self.reload.bind(this));
                })
        }).catch(function(err) {
            console.log("There was an error, please try again");
            self.setState({ loading: false });
            self.showModal("There was an error, please try again", self.reload.bind(this));
            //**TODO: send response over to SC engineers
        })
    }

    showModal(message, closeAction = function() {}) {
        this.refs.modal.show(message, closeAction);
    }

    componentDidMount() {
        this.loadWaitlist(this.state.filters);
    }

    render() {
        return (
            <div >
        <WaitlistFilters
          filters={this.state.filters}
          addCheckboxFilter={this.addCheckboxFilter.bind(this)}
          removeCheckboxFilter={this.removeCheckboxFilter.bind(this)}
          updateRadioFilter={this.updateRadioFilter.bind(this)}
          applyFilters={this.applyFilters.bind(this)}
          searchValue={this.state.search}
          updateSearch={(searchQuery)=>(this.setState({search: searchQuery}))}
          submitSearch={this.search.bind(this)}
        />
        <WaitlistUsersContainer users={this.state.users}/>
        <LoadMoreButton
          userCount={this.state.users.length}
          loading={this.state.loading}
          loadMore={this.loadMore.bind(this)}
        />
        <MessageModal
          ref="modal"
          title="Error"
          message=""
          buttonText="Close"
        />
      </div>
        )
    }
}

export default Waitlist;
